/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts'; // ✅ Import chart support
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

if (environment.production) {
  // Disable logging in production
  console.log = () => {};
  console.debug = () => {};
  console.info = () => {};  
  console.error = () => {};
}
import { MonacoEditorModule } from 'ngx-monaco-editor-v2';
import { importProvidersFrom } from '@angular/core';
import { provideServiceWorker } from '@angular/service-worker';
if (!environment.sw && 'serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(regs => {
    regs.forEach(reg => reg.unregister());
  });
}
bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [
    ...(appConfig.providers || []),
    importProvidersFrom(MonacoEditorModule.forRoot()), // ✅ correct use
    
    provideCharts(withDefaultRegisterables()), 
    provideServiceWorker('ngsw-worker.js', {
            enabled: environment.sw,
            registrationStrategy: 'registerWhenStable:30000'
          })
  ]
});


